import {
  SUBMIT_SYNC_CATEGORIES,
  SyncCategoriesRequestPayload,
  SyncCategoriesRequestAction,
  SyncJobDetailsRequestPayload,
  SyncJobDetailsRequestAction,
  FETCH_SYNC_JOB_DETAILS,
  CLEAR_SYNC_JOB_STATE,
  FETCH_CATEGORY_LATEST_SYNC,
  FetchCategoryLatestsSyncPayload,
  FetchCategoryLatestsSyncAction,
  RESET_SYNC_CATEGORY_DETAILS,
} from "./SyncCategoriesTypes";

export const submitSyncCategoriesRequest = (
  payload: SyncCategoriesRequestPayload,
): SyncCategoriesRequestAction => {
  return {
    type: SUBMIT_SYNC_CATEGORIES.REQUEST,
    payload,
  };
};

export const fetchSyncJobDetails = (
  payload: SyncJobDetailsRequestPayload,
): SyncJobDetailsRequestAction => {
  return {
    type: FETCH_SYNC_JOB_DETAILS.REQUEST,
    payload,
  };
};

export const clearSyncJobState = () => {
  return {
    type: CLEAR_SYNC_JOB_STATE,
  };
};

export const fetchCategoryLatestsSync = (
  payload: FetchCategoryLatestsSyncPayload,
): FetchCategoryLatestsSyncAction => {
  return {
    type: FETCH_CATEGORY_LATEST_SYNC.REQUEST,
    payload,
  };
};

export const resetSyncCategoryDetails = () => {
  return {
    type: RESET_SYNC_CATEGORY_DETAILS,
  };
};